// extracted by mini-css-extract-plugin
export default {"section":"DashboardMetricSection_section__ZjoQW","value":"DashboardMetricSection_value__JZIZQ","description":"DashboardMetricSection_description__lBC7q"};